import { render } from "./TopNav.vue?vue&type=template&id=279eb21c"
import script from "./TopNav.vue?vue&type=script&lang=js"
export * from "./TopNav.vue?vue&type=script&lang=js"
script.render = render

export default script